import moment from 'moment-timezone'

import { IQuestionRequirementsAge } from '../model/question'

/**
 * Returns true if the question or section passes the restriction
 */
export function checkAgeRestriction(
  dob: Date | moment.Moment,
  restriction: IQuestionRequirementsAge,
  dos = moment(),
): boolean {
  const ageInMonths = dos.diff(dob, 'months')

  switch (restriction.comparison) {
    case '<=': {
      return ageInMonths <= restriction.months
    }
    case '>=': {
      return ageInMonths >= restriction.months
    }
    case '=': {
      return ageInMonths === restriction.months
    }
    case 'BETWEEN': {
      return ageInMonths >= restriction.min && ageInMonths <= restriction.max
    }
  }
}
